import { Spinner } from 'flowbite-react';
import React from 'react';
import Container from 'src/components/shared/Container';
import DriveCard from 'src/components/placementDrives/DriveCard';
import { DRIVE_FONT_STYLE, PublicDriveHeader, useDriveFont } from 'src/components/placementDrives/shared';
import { useUserContext } from 'src/context/UserProvider';
import { useGetPublicUpcomingDrives, useGetUpcomingDrivesForJobseeker } from 'src/hooks/drives.hooks';

// All upcoming drives. Works logged out (QR code landing) and logged in (only the drives the candidate can see).
const PlacementDrivesListPage = () => {
	useDriveFont();
	const { user } = useUserContext();
	const publicDrives = useGetPublicUpcomingDrives(!user);
	const myDrives = useGetUpcomingDrivesForJobseeker(!!user);
	const { data, isLoading } = user ? myDrives : publicDrives;
	const drives = data?.drives ?? [];

	return (
		<div className="min-h-screen bg-white" style={DRIVE_FONT_STYLE}>
			{user ? null : <PublicDriveHeader />}
			<Container className="dp-fade w-[92%] max-w-[1280px] py-8 md:py-12">
				<h1 className="text-[34px] leading-[38px] md:text-[48px] md:leading-[52px] font-[800] tracking-[-0.04em] text-[#0F1626]">Upcoming drives</h1>
				<p className="mt-2 text-[15px] md:text-[17px] text-[#555770]">Explore the companies visiting for placements.</p>

				{isLoading ? (
					<div className="flex justify-center py-24">
						<Spinner size="xl" />
					</div>
				) : drives.length === 0 ? (
					<div className="mt-10 rounded-[20px] border border-[#EEEEF5] bg-[#F6F6FA] p-8 text-center text-[#555770]">
						{user ? 'No drives are open for you right now. If you are at a drive, ask the Masai staff to add you.' : 'No upcoming drives right now. Please check back soon.'}
					</div>
				) : (
					<div className="mt-8 grid gap-5 md:grid-cols-2">
						{drives.map(drive => (
							<DriveCard key={drive._id} drive={drive} className="w-full" />
						))}
					</div>
				)}
			</Container>
		</div>
	);
};

export default PlacementDrivesListPage;
